import GetPrivateData from '../Classes/GetPrivateData.js';

// if there is no intersection observer, make a fake callback entry that shows item as always being in view.
class IntersectionObserver
{
	constructor(callback)
	{
		const privateData = getPrivateData.for(this);
		privateData.callback = callback;
	}

	observe(element)
	{
		const privateData = getPrivateData.for(this);
		privateData.callback
		(
			[
				{
					target: element,
					intersectionRatio: 1,
					isIntersecting: true,
					boundingClientRect:
					{
						top:0,
						bottom:0
					},
					intersectionRect:
					{
						top:0,
						bottom:0
					}
				}
			]
		);
	}
}

const getPrivateData = new GetPrivateData(IntersectionObserver);

// if IntersectionObserver isn't available, use a quick and dirty fake one that just always reports as being visible
export default window.IntersectionObserver || IntersectionObserver;